var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 48,
    viewBox: "0 0 41 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1166 10.176C39.6172 10.68 40.0463 11.352 40.4038 12.216C40.7614 13.08 40.9283 13.848 40.9283 14.568V45.432C40.9283 46.152 40.6899 46.752 40.1893 47.256C39.6887 47.76 39.0928 48 38.3777 48H2.62187C1.90675 48 1.31082 47.76 0.810243 47.256C0.309661 46.752 0.0712891 46.152 0.0712891 45.432V2.568C0.0712891 1.848 0.309661 1.248 0.810243 0.744C1.31082 0.24 1.90675 0 2.62187 0H26.4591C27.1742 0 27.937 0.168 28.7951 0.528C29.6533 0.888 30.3207 1.32 30.8213 1.824L39.1166 10.176ZM27.3172 3.648V13.728H37.3288C37.162 13.2 36.9475 12.84 36.7329 12.624L28.4137 4.248C28.1992 4.008 27.8178 3.816 27.3172 3.648ZM37.5195 44.568V17.136H26.4591C25.744 17.136 25.148 16.896 24.6475 16.392C24.1469 15.888 23.9085 15.288 23.9085 14.568V3.432H3.48001V44.568H37.5195Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlank);
export default __webpack_public_path__ + "static/media/blank.b5562caa8e4a13c8eb3ca2d400a06feb.svg";
export { ForwardRef as ReactComponent };